import * as React from "react";
const SvgFinishMarker = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 30,
	height: 35,
	viewBox: "0 0 30 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("ellipse", {
	cx: 14.675,
	cy: 14.2434,
	rx: 14.675,
	ry: 14.2434,
	fill: "#6384E0"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M24.3477 14.2434C24.3477 19.3842 20.0455 23.6023 14.675 23.6023C9.30457 23.6023 5.00229 19.3842 5.00229 14.2434C5.00229 9.10264 9.30457 4.88462 14.675 4.88462C20.0455 4.88462 24.3477 9.10264 24.3477 14.2434Z",
	fill: "white",
	stroke: "white",
	strokeWidth: 2
}), /* @__PURE__ */ React.createElement("path", {
	d: "M14.6935 34.5294L9.31793 25.4924L20.0692 25.4924L14.6935 34.5294Z",
	fill: "#6384E0"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18.161 16.1774C18.161 16.9534 17.937 17.5414 17.489 17.9414C17.041 18.3334 16.369 18.5294 15.473 18.5294H11.837V10.2494H15.341C16.165 10.2494 16.789 10.4214 17.213 10.7654C17.645 11.1014 17.861 11.6174 17.861 12.3134C17.861 12.7454 17.757 13.1254 17.549 13.4534C17.349 13.7734 17.029 14.0134 16.589 14.1734C17.093 14.3014 17.481 14.5294 17.753 14.8574C18.025 15.1854 18.161 15.6254 18.161 16.1774ZM16.589 15.8534C16.589 15.5414 16.485 15.2934 16.277 15.1094C16.069 14.9254 15.721 14.8334 15.233 14.8334H13.349V17.3774H15.233C15.673 17.3774 16.009 17.2934 16.241 17.1254C16.473 16.9494 16.589 16.6774 16.589 16.3094V15.8534ZM16.289 12.3374C16.289 12.0254 16.185 11.7934 15.977 11.6414C15.777 11.4814 15.489 11.4014 15.113 11.4014H13.349V13.7534H15.113C15.897 13.7534 16.289 13.4134 16.289 12.7334V12.3374Z",
	fill: "#6384E0"
}));
export default SvgFinishMarker;
